import styled from 'styled-components';

/**
 * A filter chip, shared by the bundle's box flows and the tour details' stop filters. `$isAlert` marks the filter that carries something to fix, so it reads as urgent even
 * when it is not the selected one.
 */
export const FilterChip = styled.button<{ $isActive: boolean; $isAlert?: boolean }>`
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    border-radius: ${({ theme }) => theme.borderRadius};
    border: 1px solid
        ${({ theme, $isActive, $isAlert }) =>
            $isActive ? theme.ctaPrimaryColor : $isAlert ? theme.errorColor : theme.lightBorderColor};
    background-color: ${({ theme, $isActive }) => ($isActive ? theme.ctaPrimaryColor : 'transparent')};
    color: ${({ theme, $isActive, $isAlert }) =>
        $isActive ? theme.ctaPrimaryTextColor : $isAlert ? theme.errorColor : theme.textColor};
    transition:
        background-color 0.2s ease,
        border-color 0.2s ease;

    &:hover {
        border-color: ${({ theme }) => theme.ctaPrimaryColor};
    }
`;

export const FilterChips = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 15px;
`;
